var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BrandClientService } from "../../../../services/modules/brand-client.service";
import { UnitOfWorkObserver } from "../../../../utilities/unit-of-work-observer";
import { BindingEngine } from "aurelia-binding";
import { autoinject } from "aurelia-framework";
import { Guid } from "../../../../utilities/guid";
import { NotificationClientService, NotificationType } from "../../../../services/basics/notification-client.service";
import { TokenClient } from "../../../../services/authentication/token-client.service";
import { LookupClientService } from "../../../../services/lookups/lookup-client.service";
import { LookupValueQuery } from "../../../../models/lookups/lookup.models";
import { BindingSignaler } from "aurelia-templating-resources";
var ManageTemplates = /** @class */ (function () {
    function ManageTemplates(brandClientService, bindingEngine, notificationService, tokenClient, lookupClientService, bindingSignaler) {
        this.brandClientService = brandClientService;
        this.bindingEngine = bindingEngine;
        this.notificationService = notificationService;
        this.tokenClient = tokenClient;
        this.lookupClientService = lookupClientService;
        this.bindingSignaler = bindingSignaler;
        this.templates = [];
        this.filesLobby = {};
        this.filesLottery = {};
        this.cdnImages = __CDN_IMAGES__;
    }
    ManageTemplates.prototype.activate = function () {
        var _this = this;
        this.brandClientService.getTemplates().then(function (templates) {
            _this.templates = templates;
            _this._uow = UnitOfWorkObserver.getTrackingInstance(_this.bindingEngine, _this.templates, []);
        });
    };
    ManageTemplates.prototype.addTemplate = function () {
        this.templates.push({
            lobbyImagePath: null,
            lotteryImagePath: null,
            internalName: null,
            name: null,
            templateId: 0,
            isActive: true,
            isDefault: true,
            guid: Guid.generateGuid()
        });
    };
    ManageTemplates.prototype.getImagePath = function (templatePath) {
        if (!templatePath) {
            return "".concat(this.cdnImages, "/others/image-placeholder.svg");
        }
        var storageUri = this.tokenClient.storageUri;
        if (this.tokenClient.storageUri.endsWith('/')) {
            var substringed = this.tokenClient.storageUri.substr(0, this.tokenClient.storageUri.length - 1);
            storageUri = substringed;
        }
        var url = storageUri + templatePath;
        return url;
    };
    ManageTemplates.prototype.onNewFileLobby = function (template, files) {
        if (files)
            this.filesLobby[template.guid] = files.item(0);
        else {
            delete this.filesLobby[template.guid];
            template.lobbyImagePath = "";
        }
        this.bindingSignaler.signal("lobby-image-updated");
    };
    ManageTemplates.prototype.onNewFileLottery = function (template, files) {
        if (files)
            this.filesLottery[template.guid] = files.item(0);
        else {
            delete this.filesLottery[template.guid];
            template.lotteryImagePath = "";
        }
        this.bindingSignaler.signal("lottery-image-updated");
    };
    ManageTemplates.prototype.save = function () {
        var _this = this;
        var imagesLobby = [];
        var imagesLottery = [];
        if (this.filesLobby && Object.keys(this.filesLobby).length > 0) {
            var keys = Object.keys(this.filesLobby);
            imagesLobby = keys.map(function (x) { return ({ file: _this.filesLobby[x], guid: x }); });
        }
        if (this.filesLottery && Object.keys(this.filesLottery).length > 0) {
            var keys = Object.keys(this.filesLottery);
            imagesLottery = keys.map(function (x) { return ({ file: _this.filesLottery[x], guid: x }); });
        }
        return new Promise(function (resolve, reject) {
            _this.brandClientService
                .saveTemplates({ id: 0, changes: _this._uow.getChanges(), imagesLottery: imagesLottery, imagesLobby: imagesLobby })
                .then(function (response) {
                if (_this._uow) {
                    _this._uow.clearChanges();
                    _this._uow.dispose();
                    _this._uow = null;
                }
                _this.templates = response.templates;
                _this._uow = UnitOfWorkObserver.getTrackingInstance(_this.bindingEngine, _this.templates, []);
                _this.lookupClientService.clearLookupCache(LookupValueQuery.templates);
                _this.notificationService.show("Save", "Changes saved successfully", NotificationType.Success);
                resolve();
            }).catch(function (ex) {
                _this.notificationService.show("Save", "Error during save of Changes", NotificationType.Error);
                reject();
            });
        });
    };
    ManageTemplates = __decorate([
        autoinject(),
        __metadata("design:paramtypes", [BrandClientService, BindingEngine, NotificationClientService,
            TokenClient, LookupClientService, BindingSignaler])
    ], ManageTemplates);
    return ManageTemplates;
}());
export { ManageTemplates };
